<template>
  <el-dialog
    v-el-drag-dialog
    no="ReleaseJY"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ContainerPreloadJY')"
    :close-on-click-modal="false"
    width="400px"
    @close="dialogClose"
  >
    <div style="margin: 10px">
      <span v-for="(item, index) in containers" :key="index" style="fontWeight:bold">
        <span> {{ item.containerNo }}</span><span style="margin-left: 30px">{{ item.eqSize + item.eqType }}</span><br>
      </span>
    </div>
    <div class="tip-line">
      <div>
        <i class="el-icon-info icon-line" />
        <span style="margin-left:10px">{{ $t('SeaExport.ConfirmSendPackingInstructions') }}</span>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="jyTakeContainer()">{{ $t('SeaExport.yes') }}</el-button>
      <el-button @click="dialogClose">{{ $t('SeaExport.no') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { postContPreloadData } from '@/api/booking/jyWarehouse'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'

export default {
  name: 'JyContainerPreloadDialog',
  props: {
    visible: { type: Boolean, default: false },
    callback: { type: Function, default: null },
    job: { type: Object, required: true },
    containers: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      containerDesc: ''
    }
  },
  computed: {

  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.visible) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    dialogClose() {
      this.$emit('update:visible', false)
    },
    onShow() {
      this.containerDesc = ContainerUtil.getMasterJobContainerDesc(this.job)
    },
    jyTakeContainer() {
      if (!this.containers || this.containers.length === 0) {
        this.$message.warning(this.$t('SeaExport.NoData'))
        return
      }
      const warehouse = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.warehouseCmp)
      if (!warehouse) {
        this.$message.warning(this.$t('SeaExport.warehouseNotNull'))
        return
      }
      // 组装请求数据
      const jyContainerPreloadDataList = []
      for (const item of this.containers) {
        if (item.containerUsage) {
          const jyContainerPreloadItemList = []
          for (const usage of item.containerUsage) {
            // CARGO-42656 淳宏：精谕推送装箱指令时需要调整字段
            let cargoName = ''
            if (this.job.masterFlag) {
              for (const lclSlave of this.job.lclSlaves) {
                if (lclSlave.uuid === usage.jobUuid) {
                  cargoName = lclSlave.cargoChineseName
                  break
                }
              }
            } else {
              cargoName = this.job.cargoChineseName
            }
            if (cargoName && cargoName.length > 10) {
              cargoName = cargoName.substring(0, 10)
            }
            jyContainerPreloadItemList.push({
              jobNo: usage.jobNo,
              blNo: this.job.masterFlag ? usage.soNo : this.job.soNo,
              wrNo: usage.warehouseNo,
              quantity: usage.quantity,
              cargo: cargoName,
              mark: usage.mark,
              volume: usage.cubage,
              weight: usage.weight,
              remark: ''
            })
          }
          if (jyContainerPreloadItemList.length === 0) {
            continue
          }
          const jyContainerPreloadData = {
            custNo: this.job.jobNo + '-' + item.containerId,
            jyContainerPreloadItemList: jyContainerPreloadItemList
          }
          jyContainerPreloadDataList.push(jyContainerPreloadData)
        }
      }
      if (jyContainerPreloadDataList.length === 0) {
        this.$message.warning(this.$t('SeaExport.NoData'))
        return
      }
      const data = {
        jobUuid: this.job.uuid,
        jyContainerPreloadDataList: jyContainerPreloadDataList
      }
      this.loading = getLoading4Cxt()
      postContPreloadData(data).then(res => {
        if (res.data) {
          this.$message.warning(res.data)
        } else {
          this.$message.success(this.$t('SeaExport.SentSuccessfully'))
        }
        this.dialogClose()
        if (this.callback) {
          this.callback()
        }
      }).catch(() => {
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style scoped>
.tip-line {
  display: flex;
  margin-top: 30px;
  margin-bottom: 30px;
}
.icon-line {
  font-size: 12px;
  color: gray;
  margin-left: 40px;
}
</style>
